import axios from 'axios'
import qs from 'qs'

const client = axios.create({
  baseURL: '/api',
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
})

client.defaults.transformRequest = [
  (data: unknown, headers: any) => {
    const language = localStorage.getItem('language') || 'en'
    if (headers) headers.lang = language
    if (!headers?.['Content-Type']) return qs.stringify(data as any)
    return JSON.stringify(data)
  },
]

client.interceptors.response.use(
  (response) => response.data,
  (error) => {
    if (error.response?.status === 404) {
      return { status: error.response.status, data: error.response.data?.message }
    }
    return Promise.reject(error)
  },
)

export default client
